import { formatEuros } from './financial'

/**
 * Pricing utility functions for discount calculations
 */

/**
 * Round a euro amount to 2 decimal places using "round half up" rule.
 * First rounds to 4 decimals to eliminate floating-point arithmetic noise
 * (our inputs have at most 2 decimal places each), then rounds to 2 decimals.
 */
export function roundCurrency(amount: number): string {
  const fourDecimals = Math.round(amount * 10000)
  const twoDecimals = Math.round(fourDecimals / 100)
  return (twoDecimals / 100).toFixed(2)
}

/**
 * Calculate final price after applying discount percentage
 * @param basePrice - Original price (string from DB decimal or number)
 * @param discountPercent - Discount percentage (0-100)
 * @returns Final price as number
 */
export function calculateFinalPrice(
  basePrice: string | number | null | undefined,
  discountPercent: number | null | undefined,
): number {
  if (!basePrice) return 0
  const price =
    typeof basePrice === 'string' ? parseFloat(basePrice) : basePrice
  if (!discountPercent) return price
  return price * (1 - discountPercent / 100)
}

/**
 * Format price with discount for display
 * @param basePrice - Original price
 * @param discountPercent - Discount percentage
 * @returns Formatted price string (e.g., "45,00 €")
 */
export function formatPriceWithDiscount(
  basePrice: string | number | null | undefined,
  discountPercent: number | null | undefined,
): string {
  const finalPrice = calculateFinalPrice(basePrice, discountPercent)
  return formatEuros(finalPrice)
}
